export function splitActivitiesByDivider(divider, activities) {
  const shownData = { existMore: activities.existMore, activityFeedsList: [] };
  const hiddenData = { existMore: activities.existMore, activityFeedsList: [] };
  let activityCount = 0;

  activities.activityFeedsList.forEach((activitiesGroup) => {
    const shownFeeds = [];
    const hiddenFeeds = [];

    if (activityCount >= divider) {
      hiddenData.activityFeedsList.push({
        title: shownFeeds.length > 0 ? null : activitiesGroup.title,
        activityFeeds: [...activitiesGroup.activityFeeds],
      });
      return;
    }

    activitiesGroup.activityFeeds.forEach((activity) => {
      if (activityCount < divider) {
        shownFeeds.push(activity);
      } else {
        hiddenFeeds.push(activity);
      }
      activityCount++;
    });

    if (shownFeeds.length > 0) {
      shownData.activityFeedsList.push({
        title: activitiesGroup.title,
        activityFeeds: shownFeeds,
      });
    }

    if (hiddenFeeds.length > 0) {
      hiddenData.activityFeedsList.push({
        title: shownFeeds.length > 0 ? null : activitiesGroup.title,
        activityFeeds: hiddenFeeds,
      });
    }
  });

  return { shownData, hiddenData };
}